import { combineReducers } from 'redux';

import { NOTIFICATIONS_UPDATE } from './actionTypes';

export function unreadCounters(state = {}, action) {
  const { type, payload } = action;

  if (type === NOTIFICATIONS_UPDATE && payload.notifications) {
    return { ...state, ...payload.notifications };
  }
  return state;
}

export default combineReducers({
  unreadCounters,
});
